<template>
  <v-container id="registration">
    <v-row justify="center">
      <v-col lg="12">
        <div v-show="this.shouldShowRegistrationChoice">
          <v-row class="mt-6">
            <v-col cols="12">
              <v-row class="justify-center">
                <v-col md="6" lg="4">
                  <v-card>
                    <v-card-title class="text-h3">
                      Heeft u al een pas?
                    </v-card-title>
                    <v-card-text>
                      Beschikt u al over een fysieke pas klik dan hieronder op
                      ja. Klik op nee om een nieuwe digitale pas aan te maken.
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="this.choosePhysicalRegistration"
                      >
                        Ja
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="this.chooseDigitalRegistration"
                      >
                        Nee
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <MaterialCard
          :title="this.getTitle"
          color="primary"
          elevation="0"
          v-show="this.shouldShowRegistrationForm"
        >
          <v-row>
            <v-col cols="12" lg="7">
              <RegistrationForm ref="registrationForm"></RegistrationForm>
            </v-col>
            <v-col cols="12" lg="5">
              <div
                class="body-1"
                v-html="
                  $store.state.config.template_settings.registration_sidebar
                "
              ></div>
            </v-col>
          </v-row>
        </MaterialCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RegistrationForm from "./components/RegistrationForm";
import MaterialCard from "@/components/views/MaterialCard";

export default {
  mounted() {
    this.isMounted = true;
  },
  name: "Registation",
  components: { MaterialCard, RegistrationForm },
  data() {
    return {
      isMounted: false
    };
  },
  methods: {
    choosePhysicalRegistration() {
      this.$store.commit("config/choosePhysicalRegistration");
    },
    chooseDigitalRegistration() {
      this.$refs.registrationForm.models.customer_card_barcode = "";
      this.$refs.registrationForm.models.anonymous_card_barcode = "";
      this.$store.commit("config/chooseDigitalRegistration");
    }
  },
  computed: {
    shouldShowRegistrationChoice() {
      return (
        this.$store.getters["config/hasRegistrationChoice"] &&
        this.$store.state.config.registration_choice === null
      );
    },
    shouldShowRegistrationForm() {
      return (
        this.$store.getters["config/hasRegistrationChoice"] === false ||
        (this.$store.getters["config/hasRegistrationChoice"] &&
          this.$store.state.config.registration_choice !== null)
      );
    },
    getTitle() {
      const templateSettings = this.$store.state.config.template_settings;
      if (templateSettings && templateSettings.hide_registration_title) {
        return undefined;
      }
      if (templateSettings && templateSettings.registration_title) {
        return templateSettings.registration_title;
      }
      if (!this.$store.getters["config/hasRegistrationChoice"]) {
        if (this.$store.state.config.can_register_for_digital_card) {
          return this.$t("title.register_digital_card");
        } else {
          return this.$t("title.register_physical_card");
        }
      } else {
        if (this.$store.getters["config/hasChosenDigitalRegistration"]) {
          return this.$t("title.register_digital_card");
        }
        return this.$t("title.register_physical_card");
      }
    }
  }
};
</script>

<style scoped></style>
